export enum ResponseCode {
    SaveSuccessFully = 1,
    AllReadyExist = 2,
    Exception = 3,
    InputInvalid = 4,
    NotExist = 5,
    NotSuccess = 6,
    Success = 7
}